import React from 'react'

export const ToggleLeftSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.11816 12.011C6.11816 10.302 7.36685 8.99994 8.80911 8.99994H15.191C16.6333 8.99994 17.8819 10.302 17.8819 12.011C17.8819 13.72 16.6333 15.0221 15.191 15.0221H8.80911C7.36685 15.0221 6.11816 13.72 6.11816 12.011ZM8.80911 7.99994C6.72675 7.99994 5.11816 9.84181 5.11816 12.011C5.11816 14.1802 6.72675 16.0221 8.80911 16.0221H15.191C17.2734 16.0221 18.8819 14.1802 18.8819 12.011C18.8819 9.84181 17.2734 7.99994 15.191 7.99994H8.80911ZM9.17067 14.8586C10.7427 14.8586 12.017 13.5843 12.017 12.0123C12.017 10.4403 10.7427 9.16595 9.17067 9.16595C7.59869 9.16595 6.32434 10.4403 6.32434 12.0123C6.32434 13.5843 7.59869 14.8586 9.17067 14.8586Z"
        fill={props.fill || 'black'}
      />
    </svg>
  )
}
